// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/customer_review_service.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ReviewQuestionConfig } from "./review_generator_pb";
import { file_api_proto_v1_review_generator } from "./review_generator_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/customer_review_service.proto.
 */
export const file_api_proto_v1_customer_review_service: GenFile = /*@__PURE__*/
  fileDesc("CiphcGlfcHJvdG8vdjEvY3VzdG9tZXJfcmV2aWV3X3NlcnZpY2UucHJvdG8SDGFwaV9wcm90by52MSIyChpHZXRSZXZpZXdGb3JtQ29uZmlnUmVxdWVzdBIUCgxjb21wYW55X3NsdWcYASABKAkiZwobR2V0UmV2aWV3Rm9ybUNvbmZpZ1Jlc3BvbnNlEhQKDGNvbXBhbnlfbmFtZRgBIAEoCRIyCgZjb25maWcYAiABKAsyIi5hcGlfcHJvdG8udjEuUmV2aWV3UXVlc3Rpb25Db25maWcivgIKFUdlbmVyYXRlUmV2aWV3UmVxdWVzdBIUCgxjb21wYW55X3NsdWcYASABKAkSFAoHZGVhbF9pZBgCIAEoA0gAiAEBEhIKCndvcmtfdHlwZXMYAyADKAkSDwoHcmVhc29ucxgEIAMoCRITCgtpbXByZXNzaW9ucxgFIAMoCRIUCgxmcmVlX2NvbW1lbnQYBiABKAkSGgoScGVybWlzc2lvbl90b19wb3N0GAcgASgIEhUKDWNhcHRjaGFfdG9rZW4YCCABKAkSEgoKcHJlZmVjdHVyZRgJIAEoCRIMCgRjaXR5GAogASgJEhIKCm1vdGl2YXRpb24YCyABKAkSEQoJaGlnaGxpZ2h0GAwgASgJEhEKCWFnZV9ncm91cBgNIAEoCRIOCgZnZW5kZXIYDiABKAlCCgoIX2RlYWxfaWQiSQoWR2VuZXJhdGVSZXZpZXdSZXNwb25zZRIWCg5nZW5lcmF0ZWRfdGV4dBgBIAEoCRIXCg9nb29nbGVfcGxhY2VfaWQYAiABKAky5QEKFUN1c3RvbWVyUmV2aWV3U2VydmljZRJvChNHZXRSZXZpZXdGb3JtQ29uZmlnEiguYXBpX3Byb3RvLnYxLkdldFJldmlld0Zvcm1Db25maWdSZXF1ZXN0GikuYXBpX3Byb3RvLnYxLkdldFJldmlld0Zvcm1Db25maWdSZXNwb25zZSIDkAIBElsKDkdlbmVyYXRlUmV2aWV3EiMuYXBpX3Byb3RvLnYxLkdlbmVyYXRlUmV2aWV3UmVxdWVzdBokLmFwaV9wcm90by52MS5HZW5lcmF0ZVJldmlld1Jlc3BvbnNlQjNaMWdpdGh1Yi5jb20vaC1zY2FwZS9pZXNhcHVyaS9nby9hcGlfcHJvdG8vdjE7YXBpdjFiBnByb3RvMw", [file_api_proto_v1_review_generator]);

/**
 * @generated from message api_proto.v1.GetReviewFormConfigRequest
 */
export type GetReviewFormConfigRequest = Message<"api_proto.v1.GetReviewFormConfigRequest"> & {
  /**
   * @generated from field: string company_slug = 1;
   */
  companySlug: string;
};

/**
 * Describes the message api_proto.v1.GetReviewFormConfigRequest.
 * Use `create(GetReviewFormConfigRequestSchema)` to create a new message.
 */
export const GetReviewFormConfigRequestSchema: GenMessage<GetReviewFormConfigRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer_review_service, 0);

/**
 * @generated from message api_proto.v1.GetReviewFormConfigResponse
 */
export type GetReviewFormConfigResponse = Message<"api_proto.v1.GetReviewFormConfigResponse"> & {
  /**
   * 企業名（ヘッダー表示用）
   *
   * @generated from field: string company_name = 1;
   */
  companyName: string;

  /**
   * 質問項目の visibility / order
   *
   * @generated from field: api_proto.v1.ReviewQuestionConfig config = 2;
   */
  config?: ReviewQuestionConfig;
};

/**
 * Describes the message api_proto.v1.GetReviewFormConfigResponse.
 * Use `create(GetReviewFormConfigResponseSchema)` to create a new message.
 */
export const GetReviewFormConfigResponseSchema: GenMessage<GetReviewFormConfigResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer_review_service, 1);

/**
 * @generated from message api_proto.v1.GenerateReviewRequest
 */
export type GenerateReviewRequest = Message<"api_proto.v1.GenerateReviewRequest"> & {
  /**
   * @generated from field: string company_slug = 1;
   */
  companySlug: string;

  /**
   * optional な案件紐付け（?deal=<id>）
   *
   * @generated from field: optional int64 deal_id = 2;
   */
  dealId?: bigint;

  /**
   * 工事内容（最大3）
   *
   * @generated from field: repeated string work_types = 3;
   */
  workTypes: string[];

  /**
   * 当社を選んだ理由（最大2）
   *
   * @generated from field: repeated string reasons = 4;
   */
  reasons: string[];

  /**
   * 印象に残った点（複数）
   *
   * @generated from field: repeated string impressions = 5;
   */
  impressions: string[];

  /**
   * 自由記述（最大1000文字）
   *
   * @generated from field: string free_comment = 6;
   */
  freeComment: string;

  /**
   * HP掲載許可 はい/いいえ
   *
   * @generated from field: bool permission_to_post = 7;
   */
  permissionToPost: boolean;

  /**
   * Cloudflare Turnstile token
   *
   * @generated from field: string captcha_token = 8;
   */
  captchaToken: string;

  /**
   * 工事エリア 都道府県名（任意・MEO 用の地域キーワード）
   *
   * @generated from field: string prefecture = 9;
   */
  prefecture: string;

  /**
   * 工事エリア 市区町村（任意・MEO 用の地域キーワード）
   *
   * @generated from field: string city = 10;
   */
  city: string;

  /**
   * 工事のきっかけ・困っていたこと（任意・最大1000文字）
   *
   * @generated from field: string motivation = 11;
   */
  motivation: string;

  /**
   * 特に印象に残ったこと（任意・最大1000文字）
   *
   * @generated from field: string highlight = 12;
   */
  highlight: string;

  /**
   * 年代（例「30代」。任意・文体ヒント）
   *
   * @generated from field: string age_group = 13;
   */
  ageGroup: string;

  /**
   * 性別（例「男性」。任意・文体ヒント）
   *
   * @generated from field: string gender = 14;
   */
  gender: string;
};

/**
 * Describes the message api_proto.v1.GenerateReviewRequest.
 * Use `create(GenerateReviewRequestSchema)` to create a new message.
 */
export const GenerateReviewRequestSchema: GenMessage<GenerateReviewRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer_review_service, 2);

/**
 * @generated from message api_proto.v1.GenerateReviewResponse
 */
export type GenerateReviewResponse = Message<"api_proto.v1.GenerateReviewResponse"> & {
  /**
   * 生成された口コミ案
   *
   * @generated from field: string generated_text = 1;
   */
  generatedText: string;

  /**
   * Google Maps 投稿リンク生成用（writereview?placeid=）
   *
   * @generated from field: string google_place_id = 2;
   */
  googlePlaceId: string;
};

/**
 * Describes the message api_proto.v1.GenerateReviewResponse.
 * Use `create(GenerateReviewResponseSchema)` to create a new message.
 */
export const GenerateReviewResponseSchema: GenMessage<GenerateReviewResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer_review_service, 3);

/**
 * 施主向け 口コミ作成サービス (issue #2070、無認証)
 * 設計 SSOT: doc/architecture/review-generator.md
 * company_slug で企業を識別し、COMPANY_PERMISSION_TYPE_REVIEW 権限を持つ企業のみ機能する。
 * CompanyStaff 認証とは独立（無認証）。bot 防止は Cloudflare Turnstile + rate limit で担保。
 *
 * @generated from service api_proto.v1.CustomerReviewService
 */
export const CustomerReviewService: GenService<{
  /**
   * アンケートフォーム設定の取得（企業名 + 質問項目 visibility/order）
   *
   * @generated from rpc api_proto.v1.CustomerReviewService.GetReviewFormConfig
   */
  getReviewFormConfig: {
    methodKind: "unary";
    input: typeof GetReviewFormConfigRequestSchema;
    output: typeof GetReviewFormConfigResponseSchema;
  },
  /**
   * アンケート回答から口コミ案を生成し DB 保存する
   *
   * @generated from rpc api_proto.v1.CustomerReviewService.GenerateReview
   */
  generateReview: {
    methodKind: "unary";
    input: typeof GenerateReviewRequestSchema;
    output: typeof GenerateReviewResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_proto_v1_customer_review_service, 0);

